// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"8e79cf76","253":"1037b656","947":"f224bcbc"}[chunkId] + ".chunk.css";
};